var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0317 6.73583L9.72836 12.0392L6.19336 12.9233L7.07669 9.3875L12.38 4.08333M15.0317 6.73583L12.38 4.08333M15.0317 6.73583L18.1259 3.6425M12.38 4.08333L15.4742 0.990831C15.7086 0.756492 16.0265 0.624847 16.3579 0.624847C16.6894 0.624847 17.0073 0.756492 17.2417 0.990831L18.1259 1.875C18.3602 2.10941 18.4918 2.42729 18.4918 2.75875C18.4918 3.0902 18.3602 3.40809 18.1259 3.6425M18.1259 3.6425L19.0092 4.52583C19.1254 4.64191 19.2175 4.77975 19.2804 4.93146C19.3432 5.08317 19.3756 5.24578 19.3756 5.41C19.3756 5.57422 19.3432 5.73683 19.2804 5.88854C19.2175 6.04025 19.1254 6.17808 19.0092 6.29416L16.25 9.0525",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 11.875V18.125C15.625 18.4565 15.4933 18.7745 15.2589 19.0089C15.0245 19.2433 14.7065 19.375 14.375 19.375H1.875C1.54348 19.375 1.22554 19.2433 0.991117 19.0089C0.756696 18.7745 0.625 18.4565 0.625 18.125V5.625C0.625 5.29348 0.756696 4.97554 0.991117 4.74112C1.22554 4.5067 1.54348 4.375 1.875 4.375H8.125",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogs);
export default __webpack_public_path__ + "static/media/blogs.408d79cf5bae2459a8e8cf1d8a8ab156.svg";
export { ForwardRef as ReactComponent };